import {
  Action,
  ActionType,
  IMiniStressLastNotificationTimeResponse,
} from "models/stressCheck/miniStressLastNotificationTime";
import createReducer from "redux/createReducer";

export interface MiniStressLastNotificationTimeReducerType {
  loading: boolean;
  error?: string;
  miniStressLastSendNotificationTimeResponse?: IMiniStressLastNotificationTimeResponse;
}

const defaultState: MiniStressLastNotificationTimeReducerType = {
  loading: false,
  error: undefined,
  miniStressLastSendNotificationTimeResponse: undefined,
};

export const miniStressLastNotificationTimeReducer =
  createReducer<MiniStressLastNotificationTimeReducerType>(defaultState, {
    [ActionType.MINI_STRESS_LAST_NOTIFICATION_TIME](
      state: MiniStressLastNotificationTimeReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.MINI_STRESS_LAST_NOTIFICATION_TIME_ERROR](
      state: MiniStressLastNotificationTimeReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        miniStressLastSendNotificationTimeResponse: undefined,
      };
    },

    [ActionType.MINI_STRESS_LAST_NOTIFICATION_TIME_SUCCESS](
      state: MiniStressLastNotificationTimeReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        miniStressLastSendNotificationTimeResponse: action.payload,
      };
    },

    [ActionType.MINI_STRESS_LAST_NOTIFICATION_TIME_RESET](
      state: MiniStressLastNotificationTimeReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        miniStressLastSendNotificationTimeResponse: undefined,
      };
    },
  });
